import api from '../services/api';
import { Invoice } from 'types';

export const getInvoices = (): Promise<Invoice[]> => {
    return api.get('/invoices/all').then(({ data }) => data);
};
